import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Video extends React.Component {
  constructor(props) {
    super(props);

    this.video = null;

    this.state = {
      'isPlaying': false,
      'isPaused': false,
      'isEnded': false
    };

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onVideoEnd = this.handleVideoEnd.bind(this);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    this.addListeners();
  }

  /**
   * React Lifecycle Hook
   * Invoked immediately before a component is unmounted and destroyed.
   * Perform any necessary cleanup in this method
   *
   * @method  componentWillUnmount
   */
  componentWillUnmount() {
    this.removeListeners();
  }

  addListeners() {
    this.video.addEventListener('ended', this.onVideoEnd);
  }

  removeListeners() {
    this.video.removeEventListener('ended', this.onVideoEnd);
  }

  handleVideoEnd() {
    this.setState({
      'isEnded': true,
      'isPlaying': false
    });
  }

  play() {
    this.setState({
      'isPlaying': true
    });
    this.video.play();
  }

  pause() {
    this.setState({
      'isPaused': true,
      'isPlaying': false
    });
    this.video.pause();
  }

  render() {
    const { className, options, src } = this.props;

    return (
      <video
        muted
        className={className}
        ref={video => { this.video = video; }}
        src={src}
        {...this.props.options}
      >
      </video>
    );
  }
}

Video.propTypes = {
  'src': PropTypes.string,
  'options': PropTypes.object
}



// WEBPACK FOOTER //
// ./src/client/components/video/video.jsx